import { ElementType, ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { FloatingLabelProps, LabelProps } from './types';

const LabelRender = <T extends ElementType = 'label'>(
  { as, className, children, ...props }: LabelProps<T>,
  ref: ForwardedRef<Element>,
) => {
  const Component = (as ?? 'label') as ElementType;
  return (
    <Component ref={ref} className={twMerge('label', className)} {...props}>
      {children}
    </Component>
  );
};

const Label = forwardRef(LabelRender);

const FloatingLabel = forwardRef<HTMLDivElement, FloatingLabelProps>(
  ({ className, children, label, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge('floating-label', className)}
        {...props}
      >
        {children}
        <span>{label}</span>
      </div>
    );
  },
);

Label.displayName = 'Label';
FloatingLabel.displayName = 'FloatingLabel';

export { FloatingLabel, Label };
export type { FloatingLabelProps, LabelProps };
